import API from '../../../../services/api-middleware';

const baseUrl = process.env.REACT_APP_LLM_SERVER_URL;

export type RouterBandAssignment = {
  band: number;
  model_id: number | null;
  model_name?: string | null;
  provider_id?: number;
  provider_name?: string | null;
};

function authHeaders() {
  let token = localStorage.getItem('token');
  if (token !== null) {
    token = JSON.parse(token);
  }
  return { Authorization: `Bearer ${token}` };
}

export const getRouterBands = async () => {
  const response = await API(baseUrl).get('router/bands', {
    headers: authHeaders(),
  });
  return response;
};

export const saveRouterBands = async (bands: { band: number; model_id: number }[]) => {
  const response = await API(baseUrl).put('router/bands', { bands }, { headers: authHeaders() });
  return response;
};

export const syncRouterBandsFromModels = async () => {
  const response = await API(baseUrl).post(
    'router/bands/sync-from-models',
    {},
    { headers: authHeaders() },
  );
  return response;
};

export const ROUTING_BAND_META = [
  { band: 1, range: '0.00 – 0.20', hint: 'Simple Q&A, light tasks' },
  { band: 2, range: '0.21 – 0.40', hint: 'Easy follow-ups' },
  { band: 3, range: '0.41 – 0.60', hint: 'Standard work' },
  { band: 4, range: '0.61 – 0.80', hint: 'Complex coding & analysis' },
  { band: 5, range: '0.81 – 1.00', hint: 'Expert reasoning' },
] as const;
